module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_purete-8df6afc1010c1d19e8e8f8870fc90a12.png";